import { render, staticRenderFns } from "./BrochureRequestIndex.vue?vue&type=template&id=7ffa9ddc&"
import script from "./BrochureRequestIndex.vue?vue&type=script&lang=js&"
export * from "./BrochureRequestIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports